const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

/* GOWin® Store — sugerencias del carrito sin perder encabezado ni ancho móvil. */
(() => {
  'use strict';

  if (window.GowinDrawerSuggestionAddV3Installed) return;
  window.GowinDrawerSuggestionAddV3Installed = true;

  const STYLE_ID = 'gowin-drawer-stability-v3';
  let adding = false;

  const ensureStyles = () => {
    if (document.getElementById(STYLE_ID)) return;

    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      body cart-drawer #CartDrawer,
      body cart-drawer .drawer__inner,
      body cart-drawer cart-drawer-items,
      body cart-drawer .cart-drawer__form,
      body cart-drawer .drawer__contents,
      body cart-drawer .drawer__cart-items-wrapper,
      body cart-drawer .cart-items {
        width: 100% !important;
        max-width: 100% !important;
        min-width: 0 !important;
        box-sizing: border-box !important;
      }

      body cart-drawer #CartDrawer,
      body cart-drawer .drawer__inner,
      body cart-drawer cart-drawer-items,
      body cart-drawer .drawer__contents {
        overflow-x: hidden !important;
      }

      body cart-drawer .cart-item__details,
      body cart-drawer .cart-item__totals,
      body cart-drawer .cart-item__quantity {
        min-width: 0 !important;
      }

      body cart-drawer .cart-item__details {
        overflow-wrap: anywhere !important;
      }

      body cart-drawer .cart-item__price-wrapper,
      body cart-drawer .price--end,
      body cart-drawer .totals__total-value {
        white-space: nowrap !important;
      }

      @media screen and (max-height: 650px) {
        body cart-drawer .drawer__inner {
          overflow-x: hidden !important;
          overflow-y: auto !important;
        }
      }
    `;

    (document.head || document.documentElement).appendChild(style);
  };

  const syncCartIcon = (markup) => {
    const currentIcon = document.getElementById('cart-icon-bubble');
    if (!markup || !currentIcon) return;

    const doc = new DOMParser().parseFromString(markup, 'text/html');
    const section = doc.querySelector('#shopify-section-cart-icon-bubble, .shopify-section');
    const source = doc.querySelector('#cart-icon-bubble');
    const nextHTML = source?.innerHTML || section?.innerHTML || doc.body?.innerHTML;

    if (nextHTML) currentIcon.innerHTML = nextHTML.trim();
  };

  const resetDrawerPosition = (drawer) => {
    const elements = [
      drawer.querySelector('.drawer__inner'),
      drawer.querySelector('cart-drawer-items'),
      drawer.querySelector('#CartDrawer-CartItems'),
    ];

    for (const element of elements) {
      if (!element) continue;
      element.scrollTop = 0;
      element.scrollLeft = 0;
    }

    const suggestions = drawer.querySelector('[data-gowin-drawer-suggestions]');
    if (suggestions) suggestions.scrollLeft = 0;
  };

  const renderStableDrawer = (drawer, sections) => {
    const drawerMarkup = sections?.['cart-drawer'];
    if (!drawerMarkup) throw new Error('No se recibió el carrito actualizado');

    const doc = new DOMParser().parseFromString(drawerMarkup, 'text/html');
    const nextDrawer = doc.querySelector('cart-drawer');
    const nextItems = doc.querySelector('cart-drawer-items');
    const nextCartItems = doc.querySelector('#CartDrawer-CartItems');
    const nextFooter = doc.querySelector('.drawer__footer');

    const currentItems = drawer.querySelector('cart-drawer-items');
    const currentCartItems = drawer.querySelector('#CartDrawer-CartItems');
    const currentFooter = drawer.querySelector('.drawer__footer');

    if (!nextCartItems || !nextFooter || !currentCartItems || !currentFooter) {
      throw new Error('No se pudo renderizar el contenido del carrito');
    }

    currentCartItems.innerHTML = nextCartItems.innerHTML;
    currentFooter.innerHTML = nextFooter.innerHTML;

    const isEmpty = nextDrawer?.classList.contains('is-empty') || false;
    drawer.classList.toggle('is-empty', isEmpty);
    currentItems?.classList.toggle('is-empty', nextItems?.classList.contains('is-empty') || false);

    drawer.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');

    requestAnimationFrame(() => {
      resetDrawerPosition(drawer);
      requestAnimationFrame(() => resetDrawerPosition(drawer));
    });
  };

  const init = () => ensureStyles();
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init, { once: true })
    : init();

  document.addEventListener(
    'click',
    async (event) => {
      const button = event.target.closest?.('[data-gowin-drawer-add]');
      if (!button || adding) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const drawer = document.querySelector('cart-drawer');
      if (!drawer) return;

      adding = true;
      ensureStyles();

      const label = button.querySelector('span');
      const originalLabel = label?.textContent || 'Agregar';

      button.setAttribute('aria-busy', 'true');
      button.disabled = true;
      if (label) label.textContent = 'Agregando…';

      try {
        const payload = new FormData();
        payload.append('id', button.dataset.gowinDrawerAdd);
        payload.append('quantity', '1');
        payload.append('sections', 'cart-drawer,cart-icon-bubble');
        payload.append('sections_url', window.routes?.cart_url || '/cart');

        const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: payload,
        });

        const state = await response.json();
        if (!response.ok || state.status) {
          throw new Error(state.description || 'No se pudo agregar el producto');
        }

        renderStableDrawer(drawer, state.sections);
        syncCartIcon(state.sections?.['cart-icon-bubble']);

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { source: 'gowin-drawer-suggestion-v3' },
          })
        );
      } catch (error) {
        if (label) label.textContent = 'Intenta otra vez';
        button.removeAttribute('aria-busy');
        button.disabled = false;

        window.setTimeout(() => {
          if (button.isConnected && label) label.textContent = originalLabel;
        }, 1800);
      } finally {
        adding = false;
      }
    },
    true
  );
})();
